import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {SharedModule} from '../../../../core/modules/shared.module';
import {ResetPasswordDialogComponent} from './reset-password.dialog.component';

const routes = [{path: 'resetpassworddialog', component: ResetPasswordDialogComponent}];

@NgModule({
  declarations: [ResetPasswordDialogComponent],
  imports: [SharedModule, RouterModule.forChild(routes)],
  exports: [ResetPasswordDialogComponent]
})

export class ResetPasswordDialogModule {}


// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/login/reset/reset-password.dialog.module.ts